<template>
    <div class="view" id="login">
        <b-container class="pt-5">
            <b-row class="text-center">
                <b-col></b-col>
                <b-col cols="8">
                    <b-jumbotron>
                        <Icon icon="user-circle" size="8x" style="color: grey"></Icon>
                        <br/><br/>
                        <b-form @submit="login">
                            <div v-if="sessionStoreState.authenticationMethod !== 'SSO'">
                                <b-form-group id="group-login" label="Identifiant : " label-for="input-login">
                                    <b-form-input
                                            id="input-login"
                                            v-model="input.username"
                                            type="text"
                                            required
                                            placeholder="Nom">
                                    </b-form-input>
                                </b-form-group>
                                <b-form-group id="group-password" label="Mot de passe: " label-for="input-password">
                                    <b-form-input
                                            id="input-password"
                                            v-model="input.password"
                                            type="password"
                                            required
                                            placeholder="Mot de passe">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <b-button type="submit" variant="primary">
                                <div v-if="sessionStoreState.authenticationMethod !== 'SSO'">Soumettre</div>
                                <div v-if="sessionStoreState.authenticationMethod === 'SSO'">Se connecter via AD
                                    Connect
                                </div>
                            </b-button>
                        </b-form>
                        <br>
                    </b-jumbotron>
                </b-col>
                <b-col></b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
  import SessionStore from '@/stores/SessionStore'

  export default {
    name: 'Login',
    data() {
      return {
        input: {
          username: "",
          password: ""
        },
        sessionStoreState: SessionStore.state
      }
    },
    methods: {
      login(evt) {
        evt.preventDefault();
        if (this.sessionStoreState.authenticationMethod === 'SSO') {
          SessionStore.loginSaml();
        } else {
          SessionStore.doAuthentication(this.input.username, this.input.password)
              .then(() => this.$router.push("/"));
        }
      }
    }
  }
</script>